// src/components/ViewToggle/ViewToggle.jsx
import React from "react";
import "./ViewToggle.scss";

export default function ViewToggle({ view, handleSwitchView }) {
  const options = [
    { key: "list", label: "List View" },
    { key: "kanban", label: "Kanban View" },
    { key: "table", label: "Table View" },
    { key: "gantt", label: "Gantt View" },
  ];

  return (
    <div
      className="projectdashboard-viewtoggle"
      role="radiogroup"
      aria-label="Switch view"
    >
      {options.map(({ key, label }) => (
        <label className="radio" key={key}>
          <input
            type="radio"
            name="projectdashboard-view"
            checked={view === key}
            onChange={() => handleSwitchView(key)}
          />
          <span className="name">{label}</span>
        </label>
      ))}
    </div>
  );
}
